import * as React from "react";
import SectionComponent from "components/common/Section/SectionComponent";
import { LinkContainer, ReadOnlyFormGroup } from "components/common";
import Routes from "routing/Routes";
import { Button, Alert, ButtonToolbar } from "components/bootstrap";
import LicenseCheck from "license/LicenseCheck";
const OidcConfigSection = ({ backendId, groupSyncBackend, getReadableSelectionType }) => {
  const { config, selectionType } = groupSyncBackend || {};
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Group Synchronization",
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(backendId, "group_sync") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, "Edit")))
    },
    groupSyncBackend ? /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Groups Claim", value: config == null ? void 0 : config.groupsClaim }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Selection Type", value: getReadableSelectionType(selectionType) })) : /* @__PURE__ */ React.createElement(Alert, null, "OIDC Group synchronization not configured for this authentication service.")
  );
};
export default OidcConfigSection;
